import { Button, Menu } from '@mui/material'
import Icon from '@mui/material/Icon'
import React, { useState } from 'react'

import MultipleChoice from '@/app/component/atom/filters/multiple-choice'

import { getCategoryLabel } from './util'

type Props = {
  categories: string[]
  selectedCategories: string[]
  onCategoriesChange: (categories: string[]) => void
}

const WATemplatesFilter: React.FC<Props> = ({ categories, selectedCategories, onCategoriesChange }) => {
  const anchorElRef = React.useRef<HTMLButtonElement | null>(null)
  const [open, setOpen] = useState(false)

  const categoryOptions = categories.map((category) => ({
    label: getCategoryLabel(category),
    value: category,
  }))

  return (
    <>
      <Button
        endIcon={<Icon>arrow_drop_down</Icon>}
        ref={anchorElRef}
        startIcon={<Icon>filter_list</Icon>}
        variant="outlined"
        onClick={() => setOpen(true)}
      >
        Categories
      </Button>
      <Menu anchorEl={anchorElRef.current} open={open} onClose={() => setOpen(false)}>
        <MultipleChoice
          name="categories"
          options={categoryOptions}
          value={selectedCategories}
          onChange={onCategoriesChange}
          clearable
        />
      </Menu>
    </>
  )
}

export { WATemplatesFilter }
export default WATemplatesFilter
